// extracted by mini-css-extract-plugin
module.exports = {"loading-overlay":"Chart_loading-overlay__2KvCE","chart-wrapper":"Chart_chart-wrapper__achiF"};